import { Solicitacao2 } from '../generated'

export default (status: Solicitacao2['statusSolicitacao']) =>
  `${status}`